import { defineMessages } from 'react-intl';

export const bypassBlockMessages = defineMessages({
  bypassAppBanner: {
    id: 'appBanner.bypass.headline',
    defaultMessage: 'App Banner überspringen',
  },
  bypassSlotsAndMainNavigation: {
    id: 'navigation.slotsAndMain.bypass.headline',
    defaultMessage: 'Hauptnavigation überspringen',
  },
  bypassMainNavigationAndUsp: {
    id: 'navigation.main.bypass.headline',
    defaultMessage: 'Zum Hauptinhalt springen',
  },
});
